<template>
  <div class="successful-purchase">
    <div class="success">
      <AmIconMaterial
        class="success__icon text--green"
        name="check_circle"
        size="md"
      />
      <AmTypography
        :text="$t('steps.payment.paymentProcessSuccess.title')"
        text-color="success"
        typography-style="l5"
        weight="bold"
      />
    </div>
    <PurchaseUserData
      class="successful-purchase__data-user"
      :email="email"
      :telephone="telephone"
      :theme="theme"
      :city="city"
      :street="street"
      :number="number"
      :district="district"
      :complement="complement"
      :uf="uf"
      :postcode="postcode"
      :enable-address="enableAddress"
    />
    <div class="payment-summary">
      <AmTypography
        :class="`text--${theme.color}`"
        :text="$t('steps.payment.purchaseSummary.title')"
        typography-style="l5"
        weight="bold"
      />
      <PurchaseSummaryUpsell
        v-if="upsell"
        :installmentSeletedLabel="getInstallmentSelectedLabel"
        :paymentType="getPaymentType"
        :upsell="upsell"
      />
      <PurchaseSummary
        v-else
        :installmentSeletedLabel="getInstallmentSelectedLabel"
        :paymentType="getPaymentType"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import themeMixin from '@/components/mixins/themeMixin'
import PurchaseSummaryUpsell from '@/views/Checkout/partials/PurchaseSummary/Upsell/PurchaseSummaryUpsell.vue'
import PurchaseSummary from '@/views/Checkout/partials/PurchaseSummary/PurchaseSummary.vue'
import PurchaseUserData from '@/views/Checkout/partials/PurchaseUserData/PurchaseUserData.vue'

export default {
  name: 'SuccessfulPurchase',
  components: {
    PurchaseSummary,
    PurchaseSummaryUpsell,
    PurchaseUserData,
  },
  mixins: [themeMixin],
  props: {
    installmentSelectedLabel: {
      type: [String, Object],
    },
    paymentType: {
      type: String,
    },
    upsell: {
      type: Object,
    },
  },
  computed: {
    ...mapGetters('Customer', {
      email: 'getEmail',
      telephone: 'getTelephone',
      city: 'getAddressCity',
      street: 'getAddressStreet',
      number: 'getAddressStreetNumber',
      district: 'getAddressStreetDistrict',
      complement: 'getAddressStreetComplement',
      uf: 'getAddressState',
      postcode: 'getPostcode',
    }),
    ...mapGetters('Cart', {
      enableAddress: 'getEnableAddress',
    }),
    ...mapState('Checkout', {
      paymentCard: (state) => state.paymentCard,
      cart: (state) => state.cart,
      pixels: (state) => state.pixels,
    }),
    getInstallmentSelectedLabel() {
      return this.paymentCard?.installments?.label || ''
    },
    getPaymentType() {
      return this.paymentType
    },
  },
}
</script>

<style lang="scss" scoped>
.successful-purchase {
  display: flex;
  flex-direction: column;
  justify-content: center;
  &__data-user {
    margin-bottom: 1rem;
  }
  .success {
    display: flex;
    justify-content: center;
    margin-bottom: 33px;
    &__icon {
      margin: 0 10px 0 12px;
    }
  }

  @include mobile {
    .success {
      &__icon {
        margin: {
          left: 0;
        }
      }
    }
    .instruction {
      margin: {
        left: 0;
      }
    }
  }
}

.error {
  display: flex;
  flex-direction: column;
  margin: 30px 0;

  .error-title {
    display: flex;
    justify-content: center;
  }

  .error-message {
    text-align: center;
  }
}

@include mobile {
  .am-modal-mask {
    ::v-deep {
      .am-modal-wrapper {
        .am-modal-container {
          width: 90% !important;
        }
      }
      #am-modal-close {
        display: none !important;
      }
    }
  }
}
</style>
